module.exports = __webpack_public_path__ + "img/larry_with_fire_extinguisher_foam_on_face.73f2c59d.jpg";